// libs
import styled from "@emotion/styled";

import { BREAKPOINTS } from "shared/styles/base";

// mixins
import { resetButton } from "shared/styles/mixin";

export const Container = styled.form`
    width: 260px;
    padding-top: 95px;

    @media screen and (max-width: ${BREAKPOINTS.MOBILE}px) {
        width: 100%;
        padding-top: 25px;
    }

    .title-container {
        display: flex;
        margin-bottom: 30px;
        align-items: center;
    }

    .title {
        margin-bottom: 0;
    }

    .input {
        margin-bottom: 15px;
    }
`;

export const Back = styled.button`
    ${resetButton}

    display: flex;
    height: 30px;
    width: 25px;
    align-items: center;
    cursor: pointer;
`;

export const Success = styled.div`
    color: #008000;
    line-height: 1.5;
    font-size: 1rem;
`;
